/**
 * Andre Garen - zaman cekirdegi (Tur 23 EK9 \u00a74.1-4.2, \u00a74.7; EK10 \u00a72 "tek kaynak EK9 bant saati").
 * Ayarlar: window.AG_TAKVIM (snippets/ag-takvim.liquid). Butun saat kararlari burada; baska dosya saat hesaplamaz.
 * Saat her zaman Izmir saati (Europe/Istanbul, kalici UTC+3) - cihazin saat dilimi etkilemez.
 *
 * window.AGZaman:
 *   simdi()            -> Izmir saatini UTC alanlarinda tasiyan Date (getUTC* = Izmir yerel)
 *   kargo([d])         -> { durum: 'SAYAC'|'SONRA'|'SESSIZ', kalanDk, sayac: '6 SA 06 DK', kesimDk, kargoGunu }
 *                         SAYAC : bugun kargo gunu (Pzt-Cum, tatil degil) ve saat kesimden once (yarim gunde 11:00)
 *                         SESSIZ: bugun kargo gunu degil ya da kesim gecti ve yarin kargo gunu degil
 *                         SONRA : kesim gecti ve yarin kargo gunu
 *                         10 Kasim (anma): sayac yok - SAYAC durumu SONRA olarak doner (duz bilgi satiri).
 *   ozelGun([d])       -> null | { tip: 'bayram'|'anma', metin }
 *   magaza([d])        -> { acik, kapanis: '19:00', kapanisEkli: "19:00'A" }
 *   lansman([d]), outletAktif([d]) -> bool (tarih araligi, gun dahil)
 *   enGec([d])         -> { sayilan: Date, enGec: Date, gunAdi: 'Per\u015fembe' } (EK10 K3 temkinli kural)
 *   urunSatiri([d])    -> SAYAC'ta "\u00dcCRETS\u0130Z KARGO \u00b7 AYNI G\u00dcN KARGO \u0130\u00c7\u0130N 6 SA 06 DK", diger her durumda
 *                         "\u00dcCRETS\u0130Z KARGO \u00b7 EN GE\u00c7 1 \u0130\u015e G\u00dcN\u00dc \u0130\u00c7\u0130NDE KARGODA" (EK9 \u00a74.6)
 *   her(fn)            -> fn(simdi) hemen ve her dakika basinda; sekme gorunur olunca da (acik sayfada kendiliginden duser)
 */
(function () {
  'use strict';
  if (window.AGZaman) return;
  var C = window.AG_TAKVIM || {};
  var TZ = 3;
  var GUNLER = ['Pazar', 'Pazartesi', 'Sal\u0131', '\u00c7ar\u015famba', 'Per\u015fembe', 'Cuma', 'Cumartesi'];
  var SAYAC_METNI = (C.sayacMetni || 'AYNI G\u00dcN KARGO \u0130\u00c7\u0130N').trim();
  var BAYRAM_METNI = {
    '10-29': 'CUMHUR\u0130YET ' + (new Date().getUTCFullYear() - 1923) + ' YA\u015eINDA \u00b7 29 EK\u0130M',
    '04-23': '23 N\u0130SAN ULUSAL EGEMENL\u0130K VE \u00c7OCUK BAYRAMIMIZ KUTLU OLSUN',
    '05-19': "19 MAYIS ATAT\u00dcRK'\u00dc ANMA, GEN\u00c7L\u0130K VE SPOR BAYRAMIMIZ KUTLU OLSUN",
    '08-30': '30 A\u011eUSTOS ZAFER BAYRAMIMIZ KUTLU OLSUN'
  };
  var ANMA_METNI = { '11-10': '10 KASIM \u00b7 SAYGIYLA ANIYORUZ' };

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hm(s, vars) { var m = String(s || '').match(/(\d{1,2})[:.](\d{2})/); return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : vars; }
  function liste(s) { return String(s || '').split(/[,;\n]/).map(function (x) { return x.trim(); }).filter(Boolean); }
  function simdi() { return new Date(Date.now() + TZ * 36e5); }
  function anahtar(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function ayGun(d) { return pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function dk(d) { return d.getUTCHours() * 60 + d.getUTCMinutes() + d.getUTCSeconds() / 60; }
  function gunEkle(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }

  var KESIM = hm(C.kesim, 16 * 60 + 30);
  /* tatil: tam gun (kargo yok). Eski bicim "YYYY-AA-GG SS:DD" yarim gun olarak da okunur. */
  var TATIL = {}, YARIM = {};
  liste(C.tatiller).forEach(function (p) {
    var m = p.match(/^(\d{4}-\d{2}-\d{2})(?:[\s=]+(\d{1,2}[:.]\d{2}))?$/);
    if (!m) return;
    if (m[2]) YARIM[m[1]] = hm(m[2]); else TATIL[m[1]] = 1;
  });
  liste(C.yarimGunler).forEach(function (p) {
    var m = p.match(/^(\d{4}-\d{2}-\d{2})[\s=]+(\d{1,2}[:.]\d{2})$/);
    if (m) YARIM[m[1]] = hm(m[2]);
  });
  var BAYRAM = liste(C.bayramlar || '04-23,05-19,08-30,10-29');
  var ANMA = liste(C.anma || '11-10');

  /* o gunun kargo kesimi (dakika); 0 = kargo yok */
  function kesimDk(d) {
    var g = d.getUTCDay();
    if (g === 0 || g === 6) return 0;
    var k = anahtar(d);
    if (TATIL[k]) return 0;
    return Object.prototype.hasOwnProperty.call(YARIM, k) ? YARIM[k] : KESIM;
  }
  function kargoGunu(d) { return kesimDk(d) > 0; }
  function sonrakiKargoGunu(d) { var x = d, i = 0; do { x = gunEkle(x, 1); i++; } while (!kargoGunu(x) && i < 30); return x; }

  function ozelGun(d) {
    d = d || simdi();
    var a = ayGun(d);
    if (ANMA.indexOf(a) > -1) return { tip: 'anma', metin: ANMA_METNI[a] || '' };
    if (BAYRAM.indexOf(a) > -1 && BAYRAM_METNI[a]) return { tip: 'bayram', metin: BAYRAM_METNI[a] };
    return null;
  }

  function sayacYazi(kalanDk) {
    if (kalanDk < 60) return kalanDk + ' DK';
    return Math.floor(kalanDk / 60) + ' SA ' + pad(kalanDk % 60) + ' DK';
  }

  function kargo(d) {
    d = d || simdi();
    var k = kesimDk(d), su = dk(d), r = { kesimDk: k, kargoGunu: k > 0, kalanDk: 0, sayac: '' };
    if (k > 0 && su < k) {
      r.durum = 'SAYAC';
      r.kalanDk = Math.max(1, Math.ceil(k - su - 1e-9));
      r.sayac = sayacYazi(r.kalanDk);
    } else if (k > 0 && kargoGunu(gunEkle(d, 1))) {
      r.durum = 'SONRA';
    } else {
      r.durum = 'SESSIZ';
    }
    var oz = ozelGun(d);
    if (oz && oz.tip === 'anma' && r.durum === 'SAYAC') { r.durum = 'SONRA'; r.sayac = ''; r.kalanDk = 0; }
    return r;
  }

  /* Saatin Turkce yonelme eki: 19:00'a, 20:00'ye, 18:30'a (okunan son sayiya gore) */
  function ek(saat) {
    var m = String(saat).match(/(\d{1,2}):(\d{2})/); if (!m) return '';
    var n = parseInt(m[2], 10) || parseInt(m[1], 10);
    var b = n % 10, o = n % 100;
    var e = { 1: 'e', 2: 'ye', 3: 'e', 4: 'e', 5: 'e', 6: 'ya', 7: 'ye', 8: 'e', 9: 'a' }[b];
    if (!b) e = ({ 10: 'a', 20: 'ye', 30: 'a', 40: 'a', 50: 'ye' })[o] || 'a';
    return e;
  }
  function magaza(d) {
    d = d || simdi();
    var p = String(C.magazaSaatleri || '10:00-19:00').split('-');
    var ac = hm(p[0], 600), kapa = hm(p[1], 1140);
    var iso = d.getUTCDay() || 7;
    var gunler = liste(C.magazaAcikGunler || '1,2,3,4,5,6').map(Number);
    var kapali = liste(C.magazaKapaliGunler);
    var su = dk(d);
    var kap = pad(Math.floor(kapa / 60)) + ':' + pad(kapa % 60);
    return { acik: gunler.indexOf(iso) > -1 && kapali.indexOf(anahtar(d)) < 0 && su >= ac && su < kapa, kapanis: kap, kapanisEkli: kap + "'" + ek(kap).toLocaleUpperCase('tr') };
  }

  function tarihIci(d, bas, bit) {
    var k = anahtar(d || simdi());
    if (bas && k < String(bas).trim()) return false;
    if (bit && k > String(bit).trim()) return false;
    return !!(bas || bit);
  }
  function lansman(d) { return tarihIci(d, C.lansmanBas, C.lansmanBit); }
  function outletAktif(d) { return !!C.outletBitis && anahtar(d || simdi()) <= String(C.outletBitis).trim(); }

  /* EK10 K3 temkinli kural: kesimden onceki siparis o is gunune sayilir; kesimden sonra, hafta sonu ya da tatilde
     verilen siparis ertesi is gunune sayilir; "en gec" gunu sayilan gunden sonraki ilk is gunudur. */
  function enGec(d) {
    d = d || simdi();
    var k = kesimDk(d);
    var sayilan = (k > 0 && dk(d) < k) ? d : sonrakiKargoGunu(d);
    var en = sonrakiKargoGunu(sayilan);
    return { sayilan: sayilan, enGec: en, gunAdi: GUNLER[en.getUTCDay()] };
  }

  /* EK10 S035 Davete yetisir mi (temkinli): davetten onceki son tam teslim gununden geriye 3 tam teslim gunu (yarim gun ve tatil
     teslim gunu sayilmaz) -> kargoya verme gunu; ondan onceki kargo gunu kesimine kadar siparis. Tavsiyedir, kesin tarih sozu degil.
     davet('2026-10-31') -> { son: Date, gunAdi, kesim: '16:30', yetisir: bool } */
  function davet(iso, d) {
    d = d || simdi();
    var m = String(iso || '').match(/^(\d{4})-(\d{2})-(\d{2})$/); if (!m) return null;
    var x = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 12, 0)), i = 0;
    var teslim = function (g) { return kargoGunu(g) && !Object.prototype.hasOwnProperty.call(YARIM, anahtar(g)); };
    var L = gunEkle(x, -1); while (!teslim(L) && i++ < 40) L = gunEkle(L, -1);
    var S = L, n = 0; i = 0; while (n < 3 && i++ < 60) { S = gunEkle(S, -1); if (teslim(S)) n++; }
    i = 0; while (!kargoGunu(S) && i++ < 30) S = gunEkle(S, -1);
    var O = gunEkle(S, -1); i = 0; while (!kargoGunu(O) && i++ < 30) O = gunEkle(O, -1);
    var k = kesimDk(O), kes = pad(Math.floor(k / 60)) + ':' + pad(k % 60);
    var ok = anahtar(d) < anahtar(O) || (anahtar(d) === anahtar(O) && dk(d) < k);
    return { son: O, gunAdi: GUNLER[O.getUTCDay()], kesim: kes, yetisir: ok };
  }

  function urunSatiri(d) {
    var k = kargo(d);
    return k.durum === 'SAYAC'
      ? '\u00dcCRETS\u0130Z KARGO \u00b7 ' + SAYAC_METNI + ' ' + k.sayac
      : '\u00dcCRETS\u0130Z KARGO \u00b7 EN GE\u00c7 1 \u0130\u015e G\u00dcN\u00dc \u0130\u00c7\u0130NDE KARGODA';
  }

  var dinleyiciler = [], zaman = null;
  function calistir() { var t = simdi(); dinleyiciler.forEach(function (fn) { try { fn(t); } catch (e) {} }); }
  function planla() {
    clearTimeout(zaman);
    var ms = 60000 - (Date.now() % 60000) + 50;
    zaman = setTimeout(function () { calistir(); planla(); }, ms);
  }
  function her(fn) {
    dinleyiciler.push(fn);
    try { fn(simdi()); } catch (e) {}
    if (dinleyiciler.length === 1) {
      planla();
      document.addEventListener('visibilitychange', function () { if (!document.hidden) { calistir(); planla(); } });
    }
  }

  /* ---- EK10 \u00a72 zaman modulu: Izmir gun dogumu/batimi (NOAA yaklasik, dis servis yok), ay evresi, ISO hafta ---- */
  var IZMIR = { lat: 38.4237, lon: 27.1428 };
  function gunesDk(n, dogus) {
    var r = Math.PI / 180, g = 2 * Math.PI / 365 * (n - 1);
    var eq = 229.18 * (.000075 + .001868 * Math.cos(g) - .032077 * Math.sin(g) - .014615 * Math.cos(2 * g) - .040849 * Math.sin(2 * g));
    var de = .006918 - .399912 * Math.cos(g) + .070257 * Math.sin(g) - .006758 * Math.cos(2 * g) + .000907 * Math.sin(2 * g) - .002697 * Math.cos(3 * g) + .00148 * Math.sin(3 * g);
    var ha = Math.acos(Math.cos(90.833 * r) / (Math.cos(IZMIR.lat * r) * Math.cos(de)) - Math.tan(IZMIR.lat * r) * Math.tan(de)) / r;
    return 720 - 4 * (IZMIR.lon + (dogus ? ha : -ha)) - eq + TZ * 60;
  }
  /* gunes(d) -> { dogusDk, batisDk, dogus: 'HH:MM', batis: 'HH:MM', gunduz: bool } (Izmir yerel dakika) */
  function gunes(d) {
    d = d || simdi();
    var n = Math.round((Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) - Date.UTC(d.getUTCFullYear(), 0, 0)) / 864e5);
    var a = Math.round(gunesDk(n, true)), b = Math.round(gunesDk(n, false)), su = dk(d);
    var f = function (m) { return pad(Math.floor(m / 60)) + ':' + pad(m % 60); };
    return { dogusDk: a, batisDk: b, dogus: f(a), batis: f(b), gunduz: su >= a && su < b };
  }
  /* ayEvresi(d) -> { evre: 0..1 (0 yeni ay, .5 dolunay), ad: 'yeni'|'hilal'|'ilk'|'siskin'|'dolunay'|'son', dolunay, yeniAy } */
  function ayEvresi(d) {
    d = d || simdi();
    var ms = d.getTime() - TZ * 36e5, SY = 29.530588853, yeni = Date.UTC(2000, 0, 6, 18, 14);
    var e = (((ms - yeni) / 864e5) % SY + SY) % SY / SY;
    var ad = e < .033 || e > .967 ? 'yeni' : e < .22 ? 'hilal' : e < .28 ? 'ilk' : e < .467 ? 'siskin' : e < .533 ? 'dolunay' : e < .72 ? 'siskin' : e < .78 ? 'son' : 'hilal';
    return { evre: e, ad: ad, dolunay: ad === 'dolunay', yeniAy: ad === 'yeni' };
  }
  /* isoHafta(d) -> { yil, hafta } (Pazartesi 00:00 Izmir); sirayla(n, basHafta) -> 0..n-1 haftalik donus */
  function isoHafta(d) {
    d = d || simdi();
    var t = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
    var g = t.getUTCDay() || 7; t.setUTCDate(t.getUTCDate() + 4 - g);
    var y0 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return { yil: t.getUTCFullYear(), hafta: Math.ceil(((t - y0) / 864e5 + 1) / 7) };
  }
  /* haftaNo: 1970-01-05 Pazartesi'den beri gecen tam hafta (yil sinirinda kaymaz); basHafta 'YYYY-AA-GG' (o haftanin herhangi bir gunu) */
  function haftaNo(d) { return Math.floor((Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) - Date.UTC(1970, 0, 5)) / 6048e5); }
  function sirayla(n, basHafta, d) {
    d = d || simdi();
    var b = String(basHafta || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    var bas = b ? haftaNo(new Date(Date.UTC(+b[1], +b[2] - 1, +b[3]))) : 0;
    return n > 0 ? (((haftaNo(d) - bas) % n) + n) % n : 0;
  }

  window.AGZaman = {
    simdi: simdi, anahtar: anahtar, kargo: kargo, kargoGunu: kargoGunu, ozelGun: ozelGun, magaza: magaza, ek: ek,
    lansman: lansman, outletAktif: outletAktif, enGec: enGec, urunSatiri: urunSatiri, sayacMetni: SAYAC_METNI,
    sayacYazi: sayacYazi, gunler: GUNLER, davet: davet, her: her, gunes: gunes, ayEvresi: ayEvresi, isoHafta: isoHafta, sirayla: sirayla
  };
})();
